<template>
  <gmap-map
      :center="center"
      :zoom="zoom"
      :options="options"
      :map-type-id="type"
      style="width: 100%; height: 100%;"
      ref="map">

    <gmap-cluster
        v-if="showCluster"
        :styles="clusterStyles"
        :gridSize="100"
        :zoomOnClick="true"
        :enableRetinaIcons="true"
        :minimumClusterSize="10">
      <gmap-marker
          v-for="(m, index) in cmarker"
          :position="m.position"
          :clickable="true" :draggable="true"
          :icon="markerOptions"
          @click="toggleInfoWindow(m, m.id)"
          :key="index"/>
    </gmap-cluster>

    <gmap-marker
        v-else v-for="(m, index) in cmarker"
        :position="m.position"
        :clickable="true" :draggable="true"
        :icon="markerOptions"
        @click="toggleInfoWindow(m, m.id)"
        :key="index"/>

    <!--Focos de calor 3 horas-->
    <gmap-cluster
        v-if="showCluster"
        :styles="clusterStyles"
        :gridSize="100"
        :zoomOnClick="true"
        :enableRetinaIcons="true"
        :minimumClusterSize="10">
      <gmap-marker
          v-for="(m) in markers3horas"
          :position="{lat: m.lat, lng: m.lng}"
          :clickable="true"
          :icon="pinSymbol('#2196F3')"
          @click="toggleInfoWindow(m, m.id)"/>
    </gmap-cluster>

    <gmap-marker
        v-else v-for="(m) in markers3horas"
        :position="{lat: m.lat, lng: m.lng}"
        :clickable="true"
        :icon="pinSymbol('#2196F3')"
        @click="toggleInfoWindow(m, m.id)"/>

    <!--Focos de calor 6 horas-->
    <gmap-cluster
        v-if="showCluster"
        :styles="clusterStyles"
        :gridSize="100"
        :zoomOnClick="true"
        :enableRetinaIcons="true"
        :minimumClusterSize="10">
      <gmap-marker
          v-for="(m) in markers6horas"
          :position="{lat: m.lat, lng: m.lng}"
          :clickable="true"
          :icon="pinSymbol('#E74C3C')"
          @click="toggleInfoWindow(m, m.id)"/>
    </gmap-cluster>

    <gmap-marker
        v-else v-for="(m) in markers6horas"
        :position="{lat: m.lat, lng: m.lng}"
        :clickable="true"
        :icon="pinSymbol('#E74C3C')"
        @click="toggleInfoWindow(m, m.id)"/>

    <!--Focos de calor 12 horas-->
    <gmap-cluster
        v-if="showCluster"
        :styles="clusterStyles"
        :gridSize="100"
        :zoomOnClick="true"
        :enableRetinaIcons="true"
        :minimumClusterSize="10">
      <gmap-marker
          v-for="(m) in markers12horas"
          :position="{lat: m.lat, lng: m.lng}"
          :clickable="true"
          :icon="pinSymbol('#E67E22')"
          @click="toggleInfoWindow(m, m.id)"/>
    </gmap-cluster>

    <gmap-marker
        v-else v-for="(m) in markers12horas"
        :position="m.position"
        :clickable="true"
        :icon="pinSymbol('#E67E22')"
        @click="toggleInfoWindow(m, m.id)"/>

    <!--Focos de calor 24 horas-->
    <gmap-cluster
        v-if="showCluster"
        :styles="clusterStyles"
        :gridSize="100"
        :zoomOnClick="true"
        :enableRetinaIcons="true"
        :minimumClusterSize="10">
      <gmap-marker
          v-for="(m) in markers24horas"
          :position="{lat: m.lat, lng: m.lng}"
          :clickable="true"
          :icon="pinSymbol('#9B59B6')"
          @click="toggleInfoWindow(m, m.id)"/>
    </gmap-cluster>

    <gmap-marker
        v-else v-for="(m) in markers24horas"
        :position="{lat: m.lat, lng: m.lng}"
        :clickable="true"
        :icon="pinSymbol('#9B59B6')"
        @click="toggleInfoWindow(m, m.id)"/>

    <!--Focos de calor por rango horas-->
    <gmap-cluster
        v-if="showCluster"
        :styles="clusterStyles"
        :gridSize="100"
        :zoomOnClick="true"
        :enableRetinaIcons="true"
        :minimumClusterSize="10">
      <gmap-marker
          v-for="(m) in markerRangeDate"
          :position="{lat: m.lat, lng: m.lng}"
          :clickable="true"
          :icon="m.icon"
          @click="toggleInfoWindow(m, m.id)"/>
    </gmap-cluster>

    <gmap-marker
        v-else v-for="(m) in markerRangeDate"
        :position="{lat: m.lat, lng: m.lng}"
        :clickable="true"
        :icon="m.icon"
        @click="toggleInfoWindow(m, m.id)"/>

    <gmap-info-window
        :options="infoOptions"
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="infoWinOpen=false">
      <div v-html="infoContent"/>
    </gmap-info-window>

    <!--InfoWindows for WMS-->
    <gmap-info-window
        :position='{lat: wmsSelected.lat, lng: wmsSelected.lng}'
        :opened="infoBoxWMSOpen"
        @closeclick="infoBoxWMSOpen = false">
      <div>
        <div v-html="wmsSelected.content"/>
      </div>
    </gmap-info-window>
  </gmap-map>
</template>

<script>

import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import {gmapApi} from "vue2-google-maps"
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
import {LatLon} from '@/plugins/utm/utm.js';
import axios from 'axios'
import device from "vue-device-detector"
import * as Utils from '@/helpers/utils'
import {config} from '@/config.json'

Vue.use(device);

let HashMap = require('hashmap');
let shapefile = require("shapefile");
const mapMarker = new HashMap();
const mapLine = new HashMap();
const mapArea = new HashMap();
const mapKml = new HashMap();

Vue.use(VueGoogleMaps, {
  load: {
    key: config.gcp.key,
    libraries: 'places,drawing,visualization,geometry'
  }
})

export default {
  data() {
    const mapMarker = require('@/assets/img-fire-marker.png');
    const m1 = require('@/assets/icon-cluster-m1.png');
    const m2 = require('@/assets/icon-cluster-m2.png');
    const m3 = require('@/assets/icon-cluster-m3.png');
    const m4 = require('@/assets/icon-cluster-m4.png');
    const m5 = require('@/assets/icon-cluster-m5.png');

    return {
      //info windows for WMS (eventos)
      wmsSelected: {content: "", lat: 0.0, lng: 0.0},
      infoBoxWMSOpen: false,

      MODE_DRAW_AREA: 1,
      MODE_DRAW_POINT: 2,
      MODE_DRAW_LINE: 3,
      MODE_DRAW_FILE: 4,

      /**
       * maps control
       * */
      zoom: 6,
      type: "hybrid",

      markerOptions: {
        url: mapMarker,
        size: {width: 35, height: 35, f: 'px', b: 'px',},
        scaledSize: {width: 35, height: 35, f: 'px', b: 'px',},
      },
      center: {
        lat: -16.290154, lng: -64.42944
      },
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      options: {
        mapTypeControl: false,
        streetViewControl: false,
        zoomControl: true,
        zoomControlOptions: {

        },
        scaleControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false,
      },
      clusterStyles: [
        {
          url: m1,
          height: 53,
          width: 53,
        },
        {
          url: m2,
          height: 56,
          width: 56,
        },
        {
          url: m3,
          height: 66,
          width: 66,
        },
        {
          url: m4,
          height: 78,
          width: 78,
        },
        {
          url: m5,
          height: 90,
          width: 90,
        }
      ],
      drawingManager: null,
      polygonForReport: null,
      markersForReport: [],

      markers3horas: [],
      markers6horas: [],
      markers12horas: [],
      markers24horas: [],
      markers7dias: [],
      markerRangeDate: [],
      markerColorForRangeDate: "#0f4c81",

      dispositivo: false,

      showCluster: true,

      kml: [],
      wms: [],
    }
  },
  components: {
    GmapCluster
  },
  methods: {
    setShowCluster(visible) {
      this.showCluster = visible;
    },
    bindInfoWindow (marker, map, infowindow, strDescription) {
      google.maps.event.addListener(marker, 'click', function () {
        infowindow.setContent(strDescription);
        infowindow.open(map, marker);
      });
    },
    setMappingDetail(item) {
      let key = undefined;
      switch (item.idc_figura) {
        case 1: {
          key = mapArea.keys().find(it => {
            return it.id === item.id
          });
          mapArea.set(key, item);
          break;
        }
        case 2: {
          key = mapMarker.keys().find(it => {
            return it.id === item.id
          });
          mapMarker.set(key, item);
          break;
        }
        case 3: {
          key = mapLine.keys().find(it => {
            return it.id === item.id
          });
          mapLine.set(key, item);
          break;
        }
      }
    },
    saveMapping(value) {
      const self = this;
      this.$root.$emit('app-show-loading', true);
      value.mapping.lstMapeo_detalles.forEach(mappingDetail => {
        switch (mappingDetail.idc_figura) {
          case 1: {
            let polygon = mapArea.keys().find(it => {
              return it.id === mappingDetail.id
            });

            mappingDetail.lstMapeo_puntos = polygon.getPath().getArray().map(elem => (
                {"id": 0, "id_detalle": 0, "latitud": elem.lat(), "longitud": elem.lng()}
            ));
            self.removeMappingInMap(mappingDetail);
            mappingDetail.id = 0;
            break;
          }
          case 2: {
            let point = mapMarker.keys().find(it => {
              return it.id === mappingDetail.id
            });

            mappingDetail.lstMapeo_puntos = [{
              "id": 0, "id_detalle": 0, "latitud": point.getPosition().lat(), "longitud": point.getPosition().lng()
            }]
            self.removeMappingInMap(mappingDetail);
            mappingDetail.id = 0;
            break;
          }
          case 3: {
            let polyline = mapLine.keys().find(it => {
              return it.id === mappingDetail.id
            });

            mappingDetail.lstMapeo_puntos = polyline.getPath().getArray().map(elem => (
                {"id": 0, "id_detalle": 0, "latitud": elem.lat(), "longitud": elem.lng()}
            ));
            self.removeMappingInMap(mappingDetail);
            mappingDetail.id = 0;
            break;
          }
        }
      });
      let formData = new FormData();
      formData.append("mapeo", Utils.toJSON(value.mapping));
      axios
          .post(`${config.api.baseURL}/guardarMapeo`, formData, {
            headers: {"Content-Type": "multipart/form-data"},
          })
          .then((response) => {
            if (response.data.descripcion === "OK") {
              this.$root.$emit('mapping-abm-back', {});
            }
          })
          .catch(err => {
            console.log("Mapa:", err);
          })
          .finally(() => {
            this.$root.$emit('app-show-loading', false);
          })
    },
    drawPoint(mappingDetail) {
      const self = this;
      let map = self.$refs.map.$mapObject;

      let marker = new google.maps.Marker({
        position: {lat: mappingDetail.lstMapeo_puntos[0].latitud, lng: mappingDetail.lstMapeo_puntos[0].longitud},
        icon: new google.maps.MarkerImage('https://maps.gstatic.com/mapfiles/ms2/micons/green-dot.png'),
        draggable: true,
        animation: google.maps.Animation.DROP,
      });
      marker.setMap(map);
      marker.addListener("click", () => {
        this.$root.$emit("mapping-abm-dialog-item", mappingDetail);
      });
      marker.id = mappingDetail.id;
      mapMarker.set(marker, mappingDetail);
    },
    drawLine(mappingDetail) {
      const self = this;
      let map = self.$refs.map.$mapObject;

      let line = new google.maps.Polyline({
        path: mappingDetail.lstMapeo_puntos.map(elem => ({lat: elem.latitud, lng: elem.longitud})),
        geodesic: true,
        strokeColor: '#388E3C',
        strokeWeight: 5,
        draggable: true,
        editable: true,
      });
      line.setMap(map);
      line.addListener("click", () => {
        this.$root.$emit("mapping-abm-dialog-item", mappingDetail);
      });
      line.id = mappingDetail.id;
      mapLine.set(line, mappingDetail);
    },
    drawArea(mappingDetail) {
      const self = this;
      let map = self.$refs.map.$mapObject;

      let area = new google.maps.Polygon({
        paths: mappingDetail.lstMapeo_puntos.map(elem => ({lat: elem.latitud, lng: elem.longitud})),
        strokeColor: "#388E3C",
        strokeWeight: 5,
        fillColor: "#388E3C",
        fillOpacity: 0.5,
        draggable: true,
        editable: true,
      });
      area.setMap(map);
      area.addListener("click", () => {
        this.$root.$emit("mapping-abm-dialog-item", mappingDetail);
      });
      area.id = mappingDetail.id;
      mapArea.set(area, mappingDetail);
    },
    addPoint(mappingDetail) {
      const self = this;
      self.drawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: google.maps.drawing.OverlayType.MARKER,
        drawingControl: false,
      });
      self.drawingManager.setOptions({
        markerOptions: {
          animation: google.maps.Animation.DROP,
          icon: new google.maps.MarkerImage('https://maps.gstatic.com/mapfiles/ms2/micons/green-dot.png'),
          draggable: true,
          editable: true,
          flat: true,
          raiseOnDrag: true,
          clickable: true,
        }
      });
      self.drawingManager.setMap(self.$refs.map.$mapObject);

      google.maps.event.addListener(self.drawingManager, 'markercomplete', function (marker) {
        marker.id = mappingDetail.id;
        let mappingPoint = {
          "id_detalle": 0,
          "latitud": marker.getPosition().lat(),
          "longitud": marker.getPosition().lng()
        }
        mappingDetail.lstMapeo_puntos.push(mappingPoint);
        mapMarker.set(marker, mappingDetail);
        self.$root.$emit("mapping-abm-add-item", mappingDetail);

        marker.addListener("click", () => {
          self.$root.$emit("mapping-abm-dialog-item", mappingDetail);
        });
      });

      google.maps.event.addListener(self.drawingManager, 'overlaycomplete', function (e) {
        self.drawingManager.setDrawingMode(null);
      });
    },
    addLine(mappingDetail) {
      const self = this;
      self.drawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: google.maps.drawing.OverlayType.POLYLINE,
        drawingControl: false,
        polylineOptions: {
          strokeColor: '#388E3C',
          fillColor: '#33388E3C',
          strokeWeight: 5,
          draggable: true,
          editable: true
        }
      });
      self.drawingManager.setMap(self.$refs.map.$mapObject);

      google.maps.event.addListener(self.drawingManager, 'polylinecomplete', function (polyline) {
        polyline.id = mappingDetail.id;
        mappingDetail.lstMapeo_puntos = polyline.getPath().getArray().map(elem => ({
          "latitud": elem.lat(),
          "longitud": elem.lng()
        }));
        mapLine.set(polyline, mappingDetail);
        self.$root.$emit("mapping-abm-add-item", mappingDetail);

        polyline.addListener("click", () => {
          self.$root.$emit("mapping-abm-dialog-item", mappingDetail);
        });
      });

      google.maps.event.addListener(self.drawingManager, 'overlaycomplete', function (e) {
        self.drawingManager.setDrawingMode(null);
      });
    },
    addArea(mappingDetail) {
      const self = this;
      self.drawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: google.maps.drawing.OverlayType.POLYGON,
        drawingControl: false
      });
      self.drawingManager.setOptions({
        polygonOptions: {
          draggable: true,
          editable: true,
          strokeWeight: 5,
          strokeColor: '#388E3C',
          fillColor: '#388E3C',
          fillOpacity: 0.5,
        }
      });
      self.drawingManager.setMap(self.$refs.map.$mapObject);

      google.maps.event.addListener(self.drawingManager, 'polygoncomplete', function (polygon) {
        polygon.id = mappingDetail.id;
        mappingDetail.lstMapeo_puntos = polygon.getPath().getArray().map(elem => ({
          "latitud": elem.lat(),
          "longitud": elem.lng()
        }));
        mapArea.set(polygon, mappingDetail);
        self.$root.$emit("mapping-abm-add-item", mappingDetail);

        polygon.addListener("click", () => {
          self.$root.$emit("mapping-abm-dialog-item", mappingDetail);
        });
      });

      google.maps.event.addListener(self.drawingManager, 'overlaycomplete', function (e) {
        self.drawingManager.setDrawingMode(null);
      });
    },
    zoomInMappingInMap(item) {
      this.zoom = 10;
      this.center = { lat: item.lstMapeo_puntos[0].latitud, lng: item.lstMapeo_puntos[0].longitud };
    },
    setVisibilityMappingInMap(item) {
      let figure = undefined;
      switch (item.idc_figura) {
        case 1: {
          figure = mapArea.keys().find(it => {
            return it.id === item.id
          });
          break;
        }
        case 2: {
          figure = mapMarker.keys().find(it => {
            return it.id === item.id
          });
          break;
        }
        case 3: {
          figure = mapLine.keys().find(it => {
            return it.id === item.id
          });
          break;
        }
      }
      if (figure != undefined) figure.setVisible(!figure.visible);
    },
    removeMappingInMap(item) {
      let figure = undefined;
      let index = undefined;
      switch (item.idc_figura) {
        case 1: {
          index = mapArea.keys().findIndex(it => {
            return it.id === item.id
          });
          figure = mapArea.keys()[index];
          figure.setMap(null);
          mapArea.delete(figure);
          break;
        }
        case 2: {
          index = mapMarker.keys().findIndex(it => {
            return it.id === item.id
          });
          figure = mapMarker.keys()[index];
          figure.setMap(null);
          mapMarker.delete(figure);
          break;
        }
        case 3: {
          index = mapLine.keys().findIndex(it => {
            return it.id === item.id
          });
          figure = mapLine.keys()[index];
          figure.setMap(null);
          mapLine.delete(figure);
          break;
        }
      }
    },
    deselectMappingInMap(item) {
      switch (item.idc_figura) {
        case 1: {
          mapArea.keys().forEach(it => {
            if (it.id === item.id) {
              it.setOptions({strokeColor: '#388E3C', fillColor: '#388E3C', fillOpacity: 0.50})
              return;
            }
          });
          break;
        }
        case 2: {
          mapMarker.keys().forEach(it => {
            if (it.id === item.id) {
              it.setIcon("https://maps.gstatic.com/mapfiles/ms2/micons/green-dot.png")
              return;
            }
          });
          break;
        }
        case 3: {
          mapLine.keys().forEach(it => {
            if (it.id === item.id) {
              it.setOptions({strokeColor: '#388E3C'})
              return;
            }
          });
          break;
        }
      }
    },
    selectMappingInMap(item) {
      switch (item.idc_figura) {
        case 1: {
          mapArea.keys().forEach(it => {
            if (it.id === item.id) {
              it.setOptions({strokeColor: '#ec240f', fillColor: '#ec240f', fillOpacity: 0.50})
              return;
            }
          });
          break;
        }
        case 2: {
          mapMarker.keys().forEach(it => {
            if (it.id === item.id) {
              it.setIcon("https://maps.gstatic.com/mapfiles/ms2/micons/red-dot.png")
              return;
            }
          });
          break;
        }
        case 3: {
          mapLine.keys().forEach(it => {
            if (it.id === item.id) {
              it.setOptions({strokeColor: '#ec240f'})
              return;
            }
          });
          break;
        }
      }
    },
    drawAreaForReport(fcType) {
      const self = this;
      self.drawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: google.maps.drawing.OverlayType.POLYGON,
        drawingControl: false,
        polygonOptions: {
          clickable: false,
          draggable: false,
          editable: true,
          strokeWeight: 2,
          strokeColor: '#4cd862',
          fillColor: '#4cd862',
          fillOpacity: 0.50,
          zIndex: 1
        }
      });
      self.drawingManager.setMap(self.$refs.map.$mapObject);
      google.maps.event.addListener(self.drawingManager, 'overlaycomplete', function (polygon) {
        self.polygonForReport = polygon;
        let markers = [];
        switch(fcType) {
          case 3: {
            markers = self.markers3horas;
            break;
          }
          case 6: {
            markers = self.markers6horas;
            break;
          }
          case 12: {
            markers = self.markers12horas;
            break;
          }
          case 24: {
            markers = self.markers24horas;
            break;
          }
          default: {
            markers = self.markerRangeDate;
            break;
          }
        }
        markers.forEach(marker => {
          const coordinate = new google.maps.LatLng(marker.lat, marker.lng);
          const polygoneArea = new google.maps.Polygon({paths: polygon.overlay.getPath().getArray()});

          const result = google.maps.geometry.poly.containsLocation(coordinate, polygoneArea);
          if (result) {
            self.markersForReport.push(marker);
          }
        });

        self.drawingManager.setDrawingMode(null);
      });
      google.maps.event.addListener(self.drawingManager, 'polygoncomplete', function (polygon) {
        self.polygonForReport = polygon;
        const fcMarkerSelected = self.markersForReport.map(elem => ({
          "id": elem.info,
          "lat": elem.lat,
          "lng": elem.lng,
        }));

        self.$root.$emit("legend-load-report-drawing", fcMarkerSelected);
      });
    },
    removePolygoneReportInMap() {
      this.polygonForReport.setMap(null);
    },
    setZoom(value) {
      this.zoom = value;
    },
    getTypeMap() {
      return this.type;
    },
    setTypeMap(type) {
      this.type = type;
    },
    toggleInfoWindow: function (marker, idx) {
      const self = this;
      self.$root.$emit("app-show-loading", true);
      let url = `${config.api.baseURL}/obtenerFocosCalor/${marker.info}`;
      axios.get(url).then(function (response) {
        let data = JSON.parse(response.data.jsonCompleto);
        console.log(data)
        self.infoWindowPos = ({lat: data.lat, lng: data.lon,});
        self.infoContent = '';
        self.infoContent += '<p>' + `Fecha UTC: ${data.fecha_utc ? moment(data.fecha_utc).format("YYYY-MM-DD") : "-"}` + '</p>';
        self.infoContent += '<p>' + `Hora UTC: ${data.hora_utc ? data.hora_utc : "-"}` + '</p>';
        self.infoContent += '<p>' + `Fecha GMT-4: ${data.data ? moment(data.data).format("YYYY-MM-DD") : "-"}` + '</p>';
        self.infoContent += '<p>' + `Hora GMT-4: ${data.hora ? data.hora : "-"}` + '</p>';
        self.infoContent += '<p>' + `Departamento : ${data.uf ? data.uf : "-"}` + '</p>';
        self.infoContent += '<p>' + `Municipio : ${data.nom_mun ? data.nom_mun : "-"}` + '</p>';
        self.infoContent += '<p>' + `Satelite : ${data.satelite ? data.satelite : "-"}` + '</p>';
        self.infoContent += '<p>' + `Latitud : ${data.lat ? data.lat : "-"}` + '</p>';
        self.infoContent += '<p>' + `Longitud : ${data.lon ? data.lon : "-"}` + '</p>';
        self.infoContent += '<p>' + `UTM : ${(data.lat && data.lon) ? new LatLon(data.lat, data.lon).toUtm() : "-"}` + '</p>';
        self.infoContent += '<p>' + `Area Protegida Nacional : ${data.ap_nal ? data.ap_nal : "-"}` + '</p>';
        self.infoContent += '<p>' + `Area Protegida Subnacional: ${data.ap_sub ? data.ap_sub : "-"}` + '</p>';

        //check if its the same marker that was selected if yes toggle
        if (self.currentMidx === idx) {
          self.infoWinOpen = !self.infoWinOpen;
        } else {
          self.infoWinOpen = true;
          self.currentMidx = idx;
        }
      }).finally(() => {
        self.$root.$emit("app-show-loading", false);
      });
    },
    isMobile() {
      if (this.$device.ios === true) {
        this.dispositivo = true;
      } else if (this.$device.android === true) {
        this.dispositivo = true;
      } else {
        this.dispositivo = false;
      }
    },
    addMarcaReportesFocosCalorGraficoLinealBeforeMarker(marcadores) {
      const self = this;
      var map = self.$refs.map.$mapObject;
      self.zoom = 6;
      var contador = 0;

      marcadores.forEach(function (item) {
        var latitud = item.position.lat;
        var longitud = item.position.lng;
        const mapMarker = new google.maps.MarkerImage('https://maps.gstatic.com/mapfiles/ms2/micons/blue-dot.png');
        var marker = new google.maps.Marker({
          map: map,
          icon: mapMarker,
          position: {lat: latitud, lng: longitud},
          draggable: true,
          animation: google.maps.Animation.DROP,
        });
        self.infoWindowplaceMarker(map, marker, item.info);
        contador++;
      });
    },
    infoWindowplaceMarker: function (map, marker, puntoinfo) {
      const self = this;
      var activeInfoWindow;
      var url = `${config.api.baseURL}/obtenerFocosCalor/${puntoinfo}`;
      axios.get(url).then(function (response) {
        var datos;
        datos = JSON.parse(response.data.jsonCompleto);
        self.infoWindowPos = ({
              lat: datos.Lat,
              lng: datos.Lon,
            }
        );
        var dataMessage = '';

        var Nfecha, Nhora, Ndpto, Nmunicipio, Nsatelite, NLatitud, NLong, Nap_nal, Nap_sub, NUtm, NUtc;
        if (datos.Data) {
          Nfecha = moment(datos.Data).format("YYYY-MM-DD");
        } else {
          Nfecha = '-';
        }
        if (datos.hora) {
          Nhora = datos.hora;
        } else {
          Nhora = '-';
        }
        if (datos.Uf) {
          Ndpto = datos.Uf;
        } else {
          Ndpto = '-';
        }

        if (datos.NOM_MUN) {
          Nmunicipio = datos.NOM_MUN;
        } else {
          Nmunicipio = '-';
        }

        if (datos.SATELLITE) {
          Nsatelite = datos.SATELLITE;
        } else {
          Nsatelite = '-';
        }

        if (datos.Lat) {
          NLatitud = datos.Lat;
        } else {
          NLatitud = '-';
        }

        if (datos.Lon) {
          NLong = datos.Lon;
        } else {
          NLong = '-';
        }

        if (datos.Lon) {
          NLong = datos.Lon;
        } else {
          NLong = '-';
        }

        if (datos.ap_nal) {
          Nap_nal = datos.ap_nal;
        } else {
          Nap_nal = '-';
        }

        if (datos.ap_sub) {
          Nap_sub = datos.ap_sub;
        } else {
          Nap_sub = '-';
        }

        if (datos.Lat && datos.Lon) {
          var utmData = new LatLon(
              datos.Lat,
              datos.Lon).toUtm();
          NUtm = utmData.toString();
        } else {
          NUtm = '-';
        }

        if (datos.fecha_registro) {
          NUtc = datos.fecha_registro;
        } else {
          NUtc = '-';
        }

        var infoWindow = new google.maps.InfoWindow({
          content: ''
        });

        marker.addListener('click', function () {
          infoWindow.close(map, marker);
          infoWindow.setContent(dataMessage);
          infoWindow.open(map, marker);
        });
        dataMessage += '<p> Fecha : ' + Nfecha + '</p>';
        dataMessage += '<p> Hora : ' + Nhora + '</p>';
        dataMessage += '<p> UTC : ' + NUtc + '</p>';
        dataMessage += '<p> Departamento : ' + Ndpto + '</p>';
        dataMessage += '<p> Municipio : ' + Nmunicipio + '</p>';
        dataMessage += '<p> Satelite : ' + Nsatelite + '</p>';
        dataMessage += '<p> Latitud : ' + NLatitud + '</p>';
        dataMessage += '<p> Longitud : ' + NLong + '</p>';
        dataMessage += '<p> UTM : ' + NUtm + '</p>';
        dataMessage += '<p> Area Protegida Nacional : ' + Nap_nal + '</p>';
        dataMessage += '<p> Area Protegida Subnacional: ' + datos.ap_sub + '</p>';
      })

    },

    /**
     * load and remove KMZ
     * */
    loadKMZ(itemFilter) {
      let self = this;
      this.$refs.map.$mapPromise.then((map) => {
        let options = {
          map: map,
          url: itemFilter.url_web
        }
        self.kml[itemFilter.id] = new google.maps.KmlLayer(options)
      })
    },
    removeKMZ(itemFilter) {
      this.kml[itemFilter.id].setMap(null);
    },

    /**
     * load and remove WMS
     * */
    loadWMS(itemFilter, indexAt) {
      let self = this;
      let url = JSON.parse(itemFilter.url_web);

      let opacidad = 0.8;
      if (url[0] == "Mosaico_sentinel" || url[0] == "Modis_721_terra" || url[0] == "Modis_721_aqua") {
        opacidad = 1.0;
      }

      let wmsLayer = new google.maps.ImageMapType({
        getTileUrl: function (coord, zoom) {
          let proj = self.$refs.map.$mapObject.getProjection();
          let zfactor = Math.pow(2, zoom);

          // get Long Lat coordinates
          let top = proj.fromPointToLatLng(
              new google.maps.Point(coord.x * 256 / zfactor, coord.y * 256 / zfactor));
          let bot = proj.fromPointToLatLng(
              new google.maps.Point((coord.x + 1) * 256 / zfactor, (coord.y + 1) * 256 / zfactor));

          //corrections for the slight shift of the SLP (mapserver)
          let deltaX = 0.0013;
          let deltaY = 0.00058;

          //create the Bounding box string
          let bbox = (top.lng() + deltaX) + "," +
              (bot.lat() + deltaY) + "," +
              (bot.lng() + deltaX) + "," +
              (top.lat() + deltaY);

          //base WMS URL
          let wmsUrl = "https://incendios.fan-bo.org:8443/geoserver/" + url[1] + "/wms?";
          wmsUrl += "SERVICE=WMS";        //WMS service
          wmsUrl += "&REQUEST=GetMap";    //WMS operation
          wmsUrl += "&VERSION=1.1.1";     //WMS version
          wmsUrl += "&LAYERS=" + url[0];  //WMS layers
          wmsUrl += "&FORMAT=image/png";  //WMS format
          wmsUrl += "&BGCOLOR=0xFFFFFF";
          wmsUrl += "&TRANSPARENT=TRUE";
          wmsUrl += "&OUTLINE=false";
          wmsUrl += "&SRS=EPSG:4326";     //set WGS84
          wmsUrl += "&BBOX=" + bbox;      // set bounding box
          wmsUrl += "&WIDTH=256";         //tile size in google
          wmsUrl += "&HEIGHT=256";
          return wmsUrl;                 // return URL for the tile
        },
        opacity: opacidad,
        isPng: true
      });

      if (indexAt === undefined) {
        this.$refs.map.$mapObject.overlayMapTypes.push(wmsLayer);
        this.wms.push(itemFilter);
      } else {
        this.$refs.map.$mapObject.overlayMapTypes.insertAt(indexAt, wmsLayer);
        this.wms.splice(indexAt, 0, itemFilter);
      }

      google.maps.event.addListener(this.$refs.map.$mapObject, 'click', evt => {
        let self = this;

        if (self.wms.length <= 0) {
          return;
        }

        //always get last item filter with wms
        let url = JSON.parse(self.wms[self.wms.length - 1].url_web);

        var latLng = evt.latLng;
        var lat = parseFloat(latLng.lat());
        var lng = parseFloat(latLng.lng());

        var radius_degrees = self.getRadius(self.$refs.map.$mapObject.getZoom());
        var buffer_sw_y_dd = lat - radius_degrees
        var buffer_sw_x_dd = lng - radius_degrees
        var buffer_ne_y_dd = lat + radius_degrees
        var buffer_ne_x_dd = lng + radius_degrees

        var buffer_sw_dd = new google.maps.LatLng(buffer_sw_y_dd, buffer_sw_x_dd)//decimal degrees
        var buffer_ne_dd = new google.maps.LatLng(buffer_ne_y_dd, buffer_ne_x_dd)//decimal degrees

        var buffer_sw_px = self.fromLatLngToPoint(buffer_sw_dd, self.$refs.map.$mapObject);//pixels
        var buffer_ne_px = self.fromLatLngToPoint(buffer_ne_dd, self.$refs.map.$mapObject);//pixels

        var buffer_width_px = (Math.abs(buffer_ne_px.x - buffer_sw_px.x)).toFixed(0);
        var buffer_height_px = (Math.abs(buffer_ne_px.y - buffer_sw_px.y)).toFixed(0);

        var center_x_px = (buffer_width_px / 2).toFixed(0);
        var center_y_px = (buffer_height_px / 2).toFixed(0);

        var wmsUrl = "https://incendios.fan-bo.org:8443/geoserver/" + url[1] + "/wms?";
        wmsUrl += '&SERVICE=WMS';
        wmsUrl += '&VERSION=1.1.0';
        wmsUrl += '&REQUEST=GetFeatureInfo';
        wmsUrl += '&TRANSPARENT=true';
        wmsUrl += '&QUERY_LAYERS=' + url[0];
        wmsUrl += '&STYLES';
        wmsUrl += '&LAYERS=' + url[0];
        wmsUrl += '&INFO_FORMAT=application/json';
        wmsUrl += '&SRS=EPSG:4326';
        wmsUrl += '&FEATURE_COUNT=1';
        wmsUrl += '&WIDTH=' + buffer_width_px;
        wmsUrl += '&HEIGHT=' + buffer_height_px;
        wmsUrl += '&Y=' + center_y_px;
        wmsUrl += '&X=' + center_x_px;
        wmsUrl += '&BBOX=' + buffer_sw_x_dd + ',' + buffer_sw_y_dd + ',' + buffer_ne_x_dd + ',' + buffer_ne_y_dd;

        axios.get(wmsUrl)
            .then(function (response) {
              //validate exist features
              if (response.data === undefined ||
                  response.data.numberReturned === undefined ||
                  parseInt(response.data.numberReturned) <= 0) {
                return;
              } else {
                let data = response.data.features[0].properties;
                if (self.wms[self.wms.length - 1].subcategoria === 'Eventos') { //is subcategory is event
                  self.wmsSelected.content = "";
                  self.wmsSelected.content += `<p> Fecha Inicio: ${data.FInicio} </p>`;
                  self.wmsSelected.content += `<p> Fecha Fin: ${data.FFin} </p>`;
                  self.wmsSelected.content += `<p> Hoy: ${data.Hoy} </p>`;
                  self.wmsSelected.content += `<p> Nro Focos: ${data.NFocos} </p>`;
                  self.wmsSelected.content += `<p> Duración: ${data.Duracion} </p>`;
                  self.wmsSelected.content += `<p> Tipo: ${data.Tipo.replaceAll("Ã", "í")} </p>`; //replace special character Ã
                  self.wmsSelected.content += `<p> Superficie: ${data.Superficie} </p>`;
                  self.wmsSelected.lat = lat;
                  self.wmsSelected.lng = lng;

                  //open info windows
                  self.infoBoxWMSOpen = true;
                } else if (self.wms[self.wms.length - 1].categoria === 'Riesgo de incendios') { //is category is risk
                  let nivel = "-";
                  switch (data.GRAY_INDEX) {
                    case 1:
                      nivel = "Muy Bajo";
                      break;
                    case 2:
                      nivel = "Muy Bajo";
                      break;
                    case 3:
                      nivel = "Bajo";
                      break;
                    case 4:
                      nivel = "Bajo";
                      break;
                    case 5:
                      nivel = "Medio";
                      break;
                    case 6:
                      nivel = "Medio";
                      break;
                    case 7:
                      nivel = "Alto";
                      break;
                    case 8:
                      nivel = "Muy Alto";
                      break;
                    case 9:
                      nivel = "Extremo";
                      break;
                  }
                  self.wmsSelected.content = "";
                  self.wmsSelected.content = `<p> Nivel: ${nivel} </p>`;
                  self.wmsSelected.lat = lat;
                  self.wmsSelected.lng = lng;

                  //open info windows
                  self.infoBoxWMSOpen = true;
                } else if(self.wms[self.wms.length - 1].nombre.includes('Temperatura')) {
                  self.wmsSelected.content = "";
                  self.wmsSelected.content = `<p> Temperatura: ${Math.trunc(data.GRAY_INDEX)} °C </p>`;
                  self.wmsSelected.lat = lat;
                  self.wmsSelected.lng = lng;

                  //open info windows
                  self.infoBoxWMSOpen = true;
                } else if(self.wms[self.wms.length - 1].nombre.includes('Velocidad de viento')) {
                  self.wmsSelected.content = "";
                  self.wmsSelected.content = `<p> Velocidad de viento: ${Math.round(data.GRAY_INDEX * 100) / 100} (m/s) </p>`;
                  self.wmsSelected.lat = lat;
                  self.wmsSelected.lng = lng;

                  //open info windows
                  self.infoBoxWMSOpen = true;
                } else if(self.wms[self.wms.length - 1].nombre.includes('Humedad relativa')) {
                  self.wmsSelected.content = "";
                  self.wmsSelected.content = `<p> Humedad relativa: ${Math.round(data.GRAY_INDEX * 100) / 100} % </p>`;
                  self.wmsSelected.lat = lat;
                  self.wmsSelected.lng = lng;

                  //open info windows
                  self.infoBoxWMSOpen = true;
                } else if(self.wms[self.wms.length - 1].nombre.includes('Precipitación Acumulada')) {
                  self.wmsSelected.content = "";
                  self.wmsSelected.content = `<p> Precipitación acumulada: ${Math.round(data.GRAY_INDEX * 100) / 100} (ml) </p>`;
                  self.wmsSelected.lat = lat;
                  self.wmsSelected.lng = lng;

                  //open info windows
                  self.infoBoxWMSOpen = true;
                } else { //other category
                  let keys = Object.keys(data);
                  let values = Object.values(data);
                  self.wmsSelected.content = "";
                  for (let index = 0; index < keys.length; index++) {
                    self.wmsSelected.content += `<p> ${keys[index]}: ${values[index]} </p>`;
                  }
                  self.wmsSelected.lat = lat;
                  self.wmsSelected.lng = lng;

                  //open info windows
                  self.infoBoxWMSOpen = true;
                }
              }
            });

        return wmsUrl;
      });
    },
    fromLatLngToPoint(latLng, map) {
      var topRight = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
      var bottomLeft = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
      var scale = Math.pow(2, map.getZoom());
      var worldPoint = map.getProjection().fromLatLngToPoint(latLng);
      return new google.maps.Point((worldPoint.x - bottomLeft.x) * scale, (worldPoint.y - topRight.y) * scale);
    },
    getRadius(zoom) {
      var radius_px = 0.40 / 2
      var constMetersDegress = 1000;

      var scaled_zooms = {
        22: 0.02,
        21: 0.04,
        20: 0.09,
        19: 0.19,
        18: 0.37,
        17: 0.74,
        16: 1.48,
        15: 3,
        14: 6,
        13: 12,
        12: 24,
        11: 48,
        10: 95,
        9: 190,
        8: 378,
        7: 752,
        6: 1485,
        5: 2909,
        4: 5540,
        3: 10064,
        2: 16355,
        1: 21282,
        0: 30000
      }

      var radius_meters = radius_px * scaled_zooms[zoom];
      var radius_degrees = radius_meters / constMetersDegress;
      return radius_degrees;
    },
    removeWMS(itemFilter) {
      let pos = this.wms.indexOf(itemFilter);
      this.wms.splice(pos, 1);
      this.$refs.map.$mapObject.overlayMapTypes.removeAt(pos);
    },
    moveWMS(itemFilterMoved, indexAt) {
      this.removeWMS(itemFilterMoved);
      this.loadWMS(itemFilterMoved, indexAt);
    },

    /**
     * load and remove API Foco Calor
     * */
    loadAPIFocosCalor(itemFilter, type, codDep, codMun, codAPNal, codAPSub) {
      const self = this;
      self.$root.$emit("app-show-loading", true);

      axios
          .get(`${config.api.baseURL}/obtenerFocosGPS/${itemFilter.fecha}/${type}/${codDep}/${codMun}/${codAPNal}/${codAPSub}`)
          .then(function (response) {
            let data = JSON.parse(response.data.jsonCompleto);
            let initialDate = self.convertDateToUTC(new Date());
            initialDate.setHours(initialDate.getHours() - itemFilter.fecha);
            let finalDate = self.convertDateToUTC(new Date());

            let initGMT4 = initialDate
            initGMT4.setHours(initGMT4.getHours() - 4);

            let finalGMT4 = finalDate
            finalGMT4.setHours(finalGMT4.getHours() - 4);

            if (itemFilter.fecha === 3) {
              self.markers3horas = data;
            } else if (itemFilter.fecha === 6) {
              self.markers6horas = data;
            } else if (itemFilter.fecha === 12) {
              self.markers12horas = data;
            } else if (itemFilter.fecha === 24) {
              self.markers24horas = data;
            }

            self.$root.$emit("legend-set-quantity-date",
                itemFilter.id,
                data.length,
                data.filter(x => x.satelite === "NPP").length,
                data.filter(x => x.satelite === "NOAA20").length,
                initGMT4,
                finalGMT4
            );
          })
          .catch(err => {
            console.log("Mapa:", err);
          })
          .finally(() => {
            self.$root.$emit("app-show-loading", false);
          });
    },
    removeAPIFocoCalor(itemFilter) {
      if (itemFilter.fecha === 3) {
        this.markers3horas = [];
      } else if (itemFilter.fecha === 6) {
        this.markers6horas = [];
      } else if (itemFilter.fecha === 12) {
        this.markers12horas = [];
      } else if (itemFilter.fecha === 24) {
        this.markers24horas = [];
      }
    },

    /**
     * load and remove API Foco Calor By Range Date
     * */
    loadAPIFocosCalorByRange(itemFilter, type, codDep, codMun, codAPNal, codAPSub) {
      const self = this;
      self.$root.$emit("app-show-loading", true);

      let initialDateStr = moment(itemFilter.init).format('YYYY-MM-DD HH:mm')
      let finalDateStr = moment(itemFilter.final).format('YYYY-MM-DD HH:mm')

      axios
          .get(`${config.api.baseURL}/obtenerFocosGPS/${initialDateStr}/${finalDateStr}/${type}/${codDep}/${codMun}/${codAPNal}/${codAPSub}`)
          .then(function (response) {
            let data = JSON.parse(response.data.jsonCompleto);
            self.loadIconInData(itemFilter, data, itemFilter.color);
            self.markerRangeDate.push.apply(self.markerRangeDate, data);

            self.$root.$emit("legend-set-quantity-date",
                itemFilter.id,
                data.length,
                data.filter(x => x.satelite === "NPP").length,
                data.filter(x => x.satelite === "NOAA20").length,
                itemFilter.init,
                itemFilter.final
            );
          })
          .catch(err => {
            console.log("Mapa:", err);
          })
          .finally(() => {
            self.$root.$emit("app-show-loading", false);
          });
    },
    removeAPIFocoCalorByRange(itemFilter) {
      let cleanArray = [];
      this.markerRangeDate.forEach(item => {
        if (item.filterId !== itemFilter.id) {
          cleanArray.push(item);
        }
      });
      this.markerRangeDate = cleanArray;
    },
    loadIconInData(filter, data, color) {
      let self = this;
      data.forEach(item => {
        item.icon = self.pinSymbol(`#${color}`);
        item.filterId = filter.id;
      });
    },

    /**
     * Methods for maps
     * */
    pinSymbol(hexColor) {
      return {
        path: google.maps.SymbolPath.CIRCLE,
        fillColor: hexColor,
        fillOpacity: 1,
        strokeColor: hexColor,
        strokeWeight: 0.5,
        scale: 4
      };
    },

    /**
     * Utils
     * */
    convertDateToUTC(date) {
      return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    }

  },
  computed: {
    google: gmapApi,
    cmarker: function () {
      const self = this;
      return self.markers;
    },
  },
  mounted() {
    this.getTypeMap();
    this.isMobile();
  },
  created() {
    this.$root.$on("Mapa-UploadFileShp", this.getShapeFile);

    this.$root.$on("map-set-zoom", this.setZoom);
    this.$root.$on("map-set-type", this.setTypeMap);
    this.$root.$on("map-get-type", this.getTypeMap);
    this.$root.$on("map-show-cluster", this.setShowCluster);
    this.$root.$on("map-load-kmz", this.loadKMZ);
    this.$root.$on("map-remove-kmz", this.removeKMZ);
    this.$root.$on("map-load-wms", this.loadWMS);
    this.$root.$on("map-remove-wms", this.removeWMS);
    this.$root.$on("map-move-wms", this.moveWMS);
    this.$root.$on("map-load-api_foco", this.loadAPIFocosCalor);
    this.$root.$on("map-remove-api_foco", this.removeAPIFocoCalor);
    this.$root.$on("map-load-api_foco_range", this.loadAPIFocosCalorByRange);
    this.$root.$on("map-remove-api_foco_range", this.removeAPIFocoCalorByRange);
    this.$root.$on("map-draw-point", this.drawPoint);
    this.$root.$on("map-draw-line", this.drawLine);
    this.$root.$on("map-draw-area", this.drawArea);
    this.$root.$on('map-zoom-mapping', this.zoomInMappingInMap);
    this.$root.$on("map-visible-mapping", this.setVisibilityMappingInMap);
    this.$root.$on("map-remove-mapping", this.removeMappingInMap);
    this.$root.$on("map-select-mapping", this.selectMappingInMap);
    this.$root.$on("map-deselect-mapping", this.deselectMappingInMap);
    this.$root.$on("map-set-mapping-detail", this.setMappingDetail);
    this.$root.$on("map-add-point", this.addPoint);
    this.$root.$on("map-add-line", this.addLine);
    this.$root.$on("map-add-area", this.addArea);
    this.$root.$on("map-save-mapping", this.saveMapping);
    this.$root.$on("map-draw-area-report", this.drawAreaForReport);
    this.$root.$on("map-remove-polygone-report", this.removePolygoneReportInMap);
  },
  beforeDestroy() {
    this.$root.$off("Mapa-UploadFileShp", this.getShapeFile);

    this.$root.$off("map-set-zoom", this.setZoom);
    this.$root.$off("map-set-type", this.setTypeMap);
    this.$root.$off("map-get-type", this.getTypeMap);
    this.$root.$off("map-show-cluster", this.setShowCluster);
    this.$root.$off("map-load-kmz", this.loadKMZ);
    this.$root.$off("map-remove-kmz", this.removeKMZ);
    this.$root.$off("map-load-wms", this.loadWMS);
    this.$root.$off("map-remove-wms", this.removeWMS);
    this.$root.$off("map-move-wms", this.moveWMS);
    this.$root.$off("map-load-api_foco", this.loadAPIFocosCalor);
    this.$root.$off("map-remove-api_foco", this.removeAPIFocoCalor);
    this.$root.$off("map-load-api_foco_range", this.loadAPIFocosCalorByRange);
    this.$root.$off("map-remove-api_foco_range", this.removeAPIFocoCalorByRange);
    this.$root.$off("map-draw-point", this.drawPoint);
    this.$root.$off("map-draw-line", this.drawLine);
    this.$root.$off("map-draw-area", this.drawArea);
    this.$root.$off('map-zoom-mapping', this.zoomInMappingInMap);
    this.$root.$off("map-visible-mapping", this.setVisibilityMappingInMap);
    this.$root.$off("map-remove-mapping", this.removeMappingInMap);
    this.$root.$off("map-select-mapping", this.selectMappingInMap);
    this.$root.$off("map-deselect-mapping", this.deselectMappingInMap);
    this.$root.$off("map-set-mapping-detail", this.setMappingDetail);
    this.$root.$off("map-add-point", this.addPoint);
    this.$root.$off("map-add-line", this.addLine);
    this.$root.$off("map-add-area", this.addArea);
    this.$root.$off("map-save-mapping", this.saveMapping);
    this.$root.$off("map-draw-area-report", this.drawAreaForReport);
    this.$root.$off("map-remove-polygone-report", this.removePolygoneReportInMap);
  }

}
</script>